import { staticComments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">观众热评</h2>
          <p className="text-sm text-foreground-500 mt-2">来自影迷的真实反馈与推荐</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
          {staticComments.map((comment) => (
            <div key={comment.id} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-600">{comment.avatar}</span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.author}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-1 mt-3 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}